import EL from '../../EL/EL.js';
import CONSOLE, { Activate, Deactivate } from '../../COMPONENT/console/CONSOLE.js';
import DIV from '../../DOM/div/DIV.js';
import Hideable, { Hide, Show } from '../../../interface/Hideable.js';
import NAVFOOTER from '../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import NAVHEADER from '../../DOM/nav/navbar/navheader/NAVHEADER.js';
import PROGRESSBAR from '../../COMPONENT/loader/PROGRESSBAR.js';
import Switchable, { Flip } from '../../../interface/Switchable.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const loaderAttr = makeAttrStruct([
    ['id', ''],
    ['class', ''],
    ['style', '']
]);
export const loaderData = makeDataStruct([
    ['progressbar'],
    ['console'],
    ['interval', null]
]);
export const loaderModel = makeStruct([
    ['attributes', loaderAttr],
    ['data', loaderData]
]);
// Simplified Model
export function loader(id, progressBar, console) {
    return {
        attributes: loaderAttr(id, 'loader', ''),
        data: loaderData(progressBar, console)
    };
}
/** A Div showing loading details */
export default class LOADER extends DIV {
    progressBar;
    console;
    constructor(node, model) {
        super(node, model);
        this.addClass('loader');
        this.implement(new Switchable(this));
        this.progressBar = new PROGRESSBAR(this, model.data.progressbar);
        this.console = new CONSOLE(this, model.data.console).on('deactivate', () => this.do(new Deactivate(), true)); //500
        this.progressBar.on('click', () => this.console.flip());
        //this.log(value, label);
        this.interval = null;
    }
    /** keepHopeAlive()
        Increment loader by random int between 1% and 4%
        every (rand2: 500 to 4000) seconds until we hit 95%, then hold until complete
        @param {LOADER} loader This LOADER
        @param {number} value ProgressBar load percent integer
    */
    keepHopeAlive(loader, value) {
        let rand1 = Math.floor(Math.random() * 4) + 1;
        let rand2 = Math.floor(Math.random() * 4000) + 500;
        let v = value;
        this.interval = setTimeout(() => {
            if (v < 90) {
                //let rand1 = Math.floor(Math.random() * 4) + 1;
                //console.log('incrementing load', v);
                v += rand1;
                loader.progressBar.el.style.width = v + '%';
            }
            else {
                clearInterval(loader.interval);
            }
            loader.keepHopeAlive(loader, v);
        }, rand2);
    }
    /** Sets the progress bar status
        Syntactic sugar for loader.log()
        @param value Percentage as integer (ie: 50 means 50%).
        @param text Text displayed inside progress bar.
        @param delay Optional delay until dialog is hidden (milliseconds)
        @returns {Promise<LOADER>} Promise to return this LOADER after success
    */
    warn(value, text = '', delay = 2000) {
        return this.log(value, text, {
            show: true,
            toConsole: true,
            delay: delay,
            type: 'warn'
        });
    }
    /** Sets the progress bar status
        @param {number} value Percentage as integer (ie: 50 means 50%).
        @param {string} [text] Text displayed inside progress bar.
        @param {LoaderLogOptions} [options] Optional Options
        @returns {Promise<LOADER>} Promise to return this LOADER after success
    */
    log(value, text = '', options = {
        show: true,
        toConsole: true,
        delay: 300,
        type: 'info'
    }) {
        return this.chain(() => {
            clearInterval(this.interval);
            // this.progressBar.setType(options.type);
            this.progressBar.el.style.width = value + '%';
            if (typeof text !== 'undefined') {
                let txt = text.substr(0, 32) + '...';
                this.progressBar.label.setInnerHTML(txt);
                this.console.addEntry(text, options.toConsole, options.type);
            }
            if (options.type === 'warn' || options.type === 'error') {
                console.log('options.type', options.type);
                this.console.do(new Activate());
            }
            if (value < 100) {
                clearTimeout(this.logTimer);
                if (options.show) {
                    this.do(new Activate());
                    if (value !== 0) {
                        this.keepHopeAlive(this, value);
                    }
                }
            }
            else {
                // Need to add some sort of queuing logic so the object doesn't hide when multiple loading
                // processes are taking place.
                this.logTimer = window.setTimeout(() => {
                    clearTimeout(this.logTimer);
                    clearInterval(this.interval);
                    this.do(new Deactivate(), true); //, options.delay
                }, options.delay);
            }
        });
    }
}
export { Activate, CONSOLE, DIV, Deactivate, EL, Flip, Hide, Hideable, NAVFOOTER, NAVHEADER, PROGRESSBAR, Show };
